var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rightarrowIcon",
    "data-name": "f0c3e0bc-7e7d-45f6-a2d2-1fff51c056ac",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.255 47.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M23.619,47.2671a1,1,0,0,1-.707-1.707l21.92-21.92L22.912,1.72a1,1,0,0,1,1.39-1.4386l.0245.0246,22.627,22.626a.999.999,0,0,1,.0011,1.4129l-.0011.0011L24.3262,46.9742A.9992.9992,0,0,1,23.619,47.2671Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "line",
    d: "M46.2374,24.64H1a1,1,0,0,1,0-2H46.2374a1,1,0,0,1,0,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.0cafdc0c.svg";
export { ForwardRef as ReactComponent };